import { COUNTRIES, COUNTRY_ORDER, type CountryCode } from "./data";

export function mountCountrySwitcher(
  root: HTMLElement,
  initial: CountryCode,
  onChange: (code: CountryCode) => void,
): (code: CountryCode) => void {
  root.innerHTML = "";
  const cards = new Map<CountryCode, HTMLButtonElement>();

  for (const code of COUNTRY_ORDER) {
    const c = COUNTRIES[code];
    const card = document.createElement("button");
    card.type = "button";
    card.className = "boomer-card";
    card.dataset.country = code;
    card.setAttribute("aria-pressed", String(code === initial));
    card.innerHTML = `
      <div class="boomer-name">${c.character}</div>
      <div class="boomer-portrait-wrap">
        <img class="boomer-portrait" src="${c.characterImage}" alt="${c.character} caricature" loading="lazy" />
      </div>
      <div class="boomer-flag-wrap">
        <img class="boomer-flag" src="${c.flagImage}" alt="${c.shortName} flag" loading="lazy" />
      </div>
      <div class="boomer-country">${c.shortName}</div>
    `;
    card.addEventListener("click", () => {
      if (card.dataset.active === "true") return;
      setActive(code);
      onChange(code);
    });
    root.appendChild(card);
    cards.set(code, card);
  }

  function setActive(code: CountryCode) {
    for (const [c, el] of cards) {
      const active = c === code;
      el.dataset.active = String(active);
      el.setAttribute("aria-pressed", String(active));
    }
  }

  setActive(initial);
  return setActive;
}
